import { translations as navigation } from './navigation';
import { translations as landing } from './landing';
import { translations as userManagement } from './userManagement';
import { translations as invoiceConversion } from './invoiceConversion';
import { translations as faq } from './faq';
import { translations as legal } from './legal';
import { translations as blog } from './blog';
import { translations as common } from './common';
import { seoContentTranslations } from './seoContent';
import { translations as moneyBackGuarantee } from './moneyBackGuarantee';

export const translations = {
  en: {
    ...navigation.en,
    ...landing.en,
    ...userManagement.en,
    ...invoiceConversion.en,
    ...faq.en,
    ...legal.en,
    ...blog.en,
    ...common.en,
    ...moneyBackGuarantee.en,
    seoContent: seoContentTranslations.en,
  },
  de: {
    ...navigation.de,
    ...landing.de,
    ...userManagement.de,
    ...invoiceConversion.de,
    ...faq.de,
    ...legal.de,
    ...blog.de,
    ...common.de,
    ...moneyBackGuarantee.de,
    seoContent: seoContentTranslations.de,
  }
};